module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/arrow-black-a4ff4baa4544d1641a42c2ffa9c4cb2a.svg&quot;;"